import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tabs } from 'primeng/tabs';
import { Globals } from 'src/app/globals';
import { SidebarConstants } from 'src/app/layout/sidebar/Constants/sidebar.constants';
import { AuditHistoryComponent } from 'src/app/shared/components/audit-history/audit-history.component';
import { Constants } from 'src/app/shared/constants/constants.constant';
import { BaseComponent } from 'src/app/core/components/base.component';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UserProfile } from '../../../shared/models';
import { ExternalUserProfileDetailsComponent } from '../../components/external-user-profile-details/external-user-profile-details.component';

@Component({
	selector: 'app-external-user-profile',
	templateUrl: './external-user-profile.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class ExternalUserProfileComponent extends BaseComponent implements OnInit {
	private pendingTabRefresh = false;
	private _auditHistoryList?: AuditHistoryComponent;
	private _detail?: ExternalUserProfileDetailsComponent;

	referenceTypeCode: string = Constants.ReferenceType.UserProfile;

	@Input() item: UserProfile = new UserProfile();
	@ViewChild('auditHistoryList')
	set auditHistoryList(value: AuditHistoryComponent | undefined) {
		this._auditHistoryList = value;
		this.resolvePendingTabRefresh();
	}
	get auditHistoryList(): AuditHistoryComponent | undefined {
		return this._auditHistoryList;
	}

	@ViewChild('detail')
	set detail(value: ExternalUserProfileDetailsComponent | undefined) {
		this._detail = value;
		this.resolvePendingTabRefresh();
	}
	get detail(): ExternalUserProfileDetailsComponent | undefined {
		return this._detail;
	}

	@ViewChild('tabs') tabs: Tabs;
	activeTabValue = 'details';

	myProfile: boolean;

	constructor(
		appContext: AppContextService,
		public globals: Globals,
		private activatedRoute: ActivatedRoute,
		private navigationService: NavigationService
	) {
		super(appContext);
		this.appContext.ViewTitle = 'External User';
		this.appContext.BasePageCSSClass.set(Constants.BasePageCSSClass.Default);
		this.appContext.setHasTableBasedData(false);
	}

	ngOnInit(): void {
		this.util.clearMessages();
		this.activatedRoute.data.subscribe(data => {
			this.item = data.pageData.user;
			this.myProfile = data.pageData.myProfile;
			this.formMode = this.formModes.View;

			this.refreshBreadcrumbs();
			if (this.myProfile) this.appContext.ViewTitle = 'My Profile';
		});
	}

	isPage(): boolean {
		return true;
	}

	goBackToListPage() {
		this.navigationService.navigateToMenuLinks(SidebarConstants.MenuLinks.ExternalUsers);
	}

	refreshBreadcrumbs() {
		if (!this.myProfile) this.setBreadcrumb([this.item.ClientName, this.item.BusinessEntityName, this.item.DisplayName]);
	}

	detailsUpdated(event: UserProfile) {
		this.item = event;
		this.formMode = this.formModes.View;

		this.refreshBreadcrumbs();
	}

	editCancelled() {
		if (this.formMode == this.formModes.Create) {
			this.goBackToListPage();
		}
	}

	tabOnChange(event: string) {
		this.util.clearMessages();
		this.activeTabValue = event;
		this.pendingTabRefresh = true;
		this.resolvePendingTabRefresh();
	}

	private resolvePendingTabRefresh() {
		if (this.pendingTabRefresh && this.refreshData()) {
			this.pendingTabRefresh = false;
		}
	}

	refreshData(): boolean {
		if (this.activeTabValue) {
			this.appContext.setHasTableBasedData(false);

			switch (this.activeTabValue) {
				case 'details': {
					if (!this.detail) return false;
					this.detail?.refreshData();
					return true;
				}
				case 'activity': {
					if (!this.auditHistoryList) return false;
					this.appContext.setHasTableBasedData(true);
					this.auditHistoryList?.refreshData();
					return true;
				}
				default:
					throw Error('Unhandled refresh for tab ' + this.activeTabValue);
			}
		}

		return true;
	}
}
